// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  BulkActionResult,
  BulkActionResultFromJSON,
  BulkActionResultToJSON,
  BulkLinkTestCasesPayload,
  BulkLinkTestCasesPayloadFromJSON,
  BulkLinkTestCasesPayloadToJSON,
  BulkUnlinkTestCasesPayload,
  BulkUnlinkTestCasesPayloadFromJSON,
  BulkUnlinkTestCasesPayloadToJSON,
  Linkedtestcase,
  LinkedtestcaseFromJSON,
  LinkedtestcaseToJSON,
  LinkedtestcasePayload,
  LinkedtestcasePayloadFromJSON,
  LinkedtestcasePayloadToJSON,
  TCError,
  TCErrorFromJSON,
  TCErrorToJSON,
} from "../models";

export interface BulkLinkTestCaseRequest {
  bulkLinkTestCasesPayload?: BulkLinkTestCasesPayload;
}

export interface BulkUnlinkTestCaseRequest {
  bulkUnlinkTestCasesPayload?: BulkUnlinkTestCasesPayload;
}

export interface CreateLinkedTestcaseRequest {
  linkedtestcasePayload?: LinkedtestcasePayload;
}

export interface GetLinkedTestCasesRequest {
  project: number;
  limit?: number;
  start?: number;
  sort?: string;
  filter?: string;
}

/**
 * no description
 */
export class LinkedtestcasesApi extends runtime.BaseAPI {
  /**
   * Bulk copy of Test Cases
   * Link bulk test cases
   */
  async bulkLinkTestCaseRaw(
    requestParameters: BulkLinkTestCaseRequest
  ): Promise<runtime.ApiResponse<BulkActionResult>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/linkedtestcases/bulkLink`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: BulkLinkTestCasesPayloadToJSON(
        requestParameters.bulkLinkTestCasesPayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BulkActionResultFromJSON(jsonValue)
    );
  }

  /**
   * Bulk copy of Test Cases
   * Link bulk test cases
   */
  async bulkLinkTestCase(
    requestParameters: BulkLinkTestCaseRequest
  ): Promise<BulkActionResult> {
    const response = await this.bulkLinkTestCaseRaw(requestParameters);
    return await response.value();
  }

  /**
   * Bulk unlink of linked test cases
   * Unlink bulk test cases
   */
  async bulkUnlinkTestCaseRaw(
    requestParameters: BulkUnlinkTestCaseRequest
  ): Promise<runtime.ApiResponse<BulkActionResult>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/linkedtestcases/bulkUnlink`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: BulkUnlinkTestCasesPayloadToJSON(
        requestParameters.bulkUnlinkTestCasesPayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BulkActionResultFromJSON(jsonValue)
    );
  }

  /**
   * Bulk unlink of linked test cases
   * Unlink bulk test cases
   */
  async bulkUnlinkTestCase(
    requestParameters: BulkUnlinkTestCaseRequest
  ): Promise<BulkActionResult> {
    const response = await this.bulkUnlinkTestCaseRaw(requestParameters);
    return await response.value();
  }

  /**
   * Linked test case to add
   * Create a new linked project
   */
  async createLinkedTestcaseRaw(
    requestParameters: CreateLinkedTestcaseRequest
  ): Promise<runtime.ApiResponse<LinkedtestcasePayload>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/linkedtestcases`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: LinkedtestcasePayloadToJSON(
        requestParameters.linkedtestcasePayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LinkedtestcasePayloadFromJSON(jsonValue)
    );
  }

  /**
   * Linked test case to add
   * Create a new linked project
   */
  async createLinkedTestcase(
    requestParameters: CreateLinkedTestcaseRequest
  ): Promise<LinkedtestcasePayload> {
    const response = await this.createLinkedTestcaseRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get list of linked test cases
   * Get list of linked test cases
   */
  async getLinkedTestCasesRaw(
    requestParameters: GetLinkedTestCasesRequest
  ): Promise<runtime.ApiResponse<Array<Linkedtestcase>>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getLinkedTestCases."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.sort !== undefined) {
      queryParameters["_sort"] = requestParameters.sort;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/linkedtestcases`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(LinkedtestcaseFromJSON)
    );
  }

  /**
   * Get list of linked test cases
   * Get list of linked test cases
   */
  async getLinkedTestCases(
    requestParameters: GetLinkedTestCasesRequest
  ): Promise<Array<Linkedtestcase>> {
    const response = await this.getLinkedTestCasesRaw(requestParameters);
    return await response.value();
  }
}
